
/**
 * Authentication configuration utilities
 * Handles environment detection and URL generation for auth flows
 */

export const getEnvironmentConfig = () => {
  const currentOrigin = window.location.origin;
  const isLocalhost = currentOrigin.includes('localhost') || currentOrigin.includes('127.0.0.1');
  const isLovableStaging = currentOrigin.includes('.lovableproject.com');
  const isSnapRefund = currentOrigin.includes('snaprefund.com');
  
  console.log('Environment detection:', {
    currentOrigin,
    isLocalhost,
    isLovableStaging,
    isSnapRefund
  });
  
  return {
    currentOrigin,
    isLocalhost,
    isLovableStaging,
    isSnapRefund,
    isProduction: isSnapRefund
  };
};

export const getAuthRedirectUrl = (path: string = '/auth') => {
  const env = getEnvironmentConfig();
  
  // Always use snaprefund.com for password reset in production
  // For development, use current origin
  let redirectUrl: string;
  
  if (env.isSnapRefund || (!env.isLocalhost && !env.isLovableStaging)) {
    redirectUrl = `https://snaprefund.com${path}`;
  } else {
    redirectUrl = `${env.currentOrigin}${path}`;
  }
  
  console.log('Auth redirect URL:', {
    environment: env.isLocalhost ? 'localhost' : env.isSnapRefund ? 'production' : 'staging',
    redirectUrl
  });
  
  return redirectUrl;
};

export const getPasswordResetRedirectUrl = () => {
  // Always use snaprefund.com for password reset
  return 'https://snaprefund.com/auth?reset=true';
};

export const getProductionUrl = () => {
  // Always return the production URL
  return 'https://snaprefund.com';
};
